enum TipoBuscaNotaFiscalSaida {
    Numero = 0,
    Serie = 1,
    Venda = 2,
    NomeCliente = 3,
    RazaoSocialCliente = 4,
    NomeFornecedor = 5,
    RazaoSocialFornecedor = 6,
    ValorTotalNota = 7,
}

export default TipoBuscaNotaFiscalSaida;

